<template>
  <div id="app">
    <div v-if="channelId !== null && staticDataReady">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    channelId() {
      return this.$store.getters.channelId
    },
    isTest() {
      return this.$route.query.test !== undefined
    }
  },
  methods: {
    init(channelId) {
      let language = localStorage.getItem(`language_${channelId}`)

      if (language === null) {
        switch (channelId) {
          case '131439345':
          case '728783472':
          case '728784987':
          case '728785240':
            language = 'es'
            break
          case '35631192':
          case '65504150':
          case '65504552':
          case '65504582':
            language = 'ru'
            break
          default:
            language = 'en'
        }
      }

      this.dataLanguage = language

      localStorage.setItem(`language_${channelId}`, language)

      // Initialize Static Data
      this.initializeStaticData()
    },
    getTestChannel(channelId) {
      switch (channelId) {
        case 'dev':
          return '745697235'
        case 'pgl':
          return '87056709'
        case 'pgl2':
          return '194701696'
        case 'dota2ti':
          return '35630634'
        default:
          return channelId
      }
    }
  },
  mounted() {
    // Authenticate Twitch Channel
    window.Twitch.ext.onAuthorized((auth) => {
      this.$store.commit('SetChannelId', auth.channelId)
      this.init(auth.channelId)
    })
    // Set Twitch Stream Latency
    window.Twitch.ext.onContext((context) => {
      this.$store.commit('SetStreamLatency', context.hlsLatencyBroadcaster)
    })

    const channelId = this.$route.query.channel
    if (this.isTest) {
      if (channelId) {
        this.$store.commit('SetChannelId', this.getTestChannel(channelId))
        this.init(this.getTestChannel(channelId))
      } else {
        this.$store.commit('SetChannelId', 'test')
        this.init('test')
      }
      this.$store.commit('SetStreamLatency', 0)
    } else if (channelId) {
      this.$store.commit('SetChannelId', this.getTestChannel(channelId))
      this.init(this.getTestChannel(channelId))
    }
  }
}
</script>
